export default __webpack_public_path__ + "static/media/retain4.4ee78269.svg";